import React from "react";
import { Col, Row, Input, Button } from "reactstrap";
import moment from "moment";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { TableDateFormat } from "../../Dashboard/DashboardVariables";

const ItemReceivingForm = (props) => {
	const { inspectionBy, inspectionDate, receivedBy, receivedDate } =
		props.itemReceivingSection;
	return (
		<>
			<div className=" my-4 formInfoContainer">
				<div className="formInfoContainerHeader">
					<h2 className="itemReceivingFormLabel">Item Receiving</h2>
				</div>

				<Row className="py-2 px-4 align-items-center">
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Received Date</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader">
							{receivedDate ? (
								<p className="formValueContainer">
									{moment(receivedDate).format(
										TableDateFormat
									)}
								</p>
							) : (
								" "
							)}
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Received By</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader">
							<p className="formValueContainer">{receivedBy}</p>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Receiving Comments</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader">
							<Input
								type="textarea"
								name="receivingComments"
								className="supervisorComments"
								value={props.formFields?.receivingComments}
								maxLength="400"
								onChange={props.itemHandleChange}
							/>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Inspection Date</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader">
							{inspectionDate ? (
								<p className="formValueContainer">
									{moment(inspectionDate).format(
										TableDateFormat
									)}
								</p>
							) : (
								""
							)}
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Inspected By</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader inspectionBy-text">
							{inspectionBy}
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Inspection Details</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader mt-2">
							<Input
								type="textarea"
								name="inspectionDetail"
								className="supervisorComments"
								value={props.formFields?.inspectionDetail}
								maxLength="400"
								onChange={props.itemHandleChange}
							/>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="emg-Contact-Info">
							<div>Received Status</div>
						</div>
					</Col>
					<Col md={12} lg={2}>
						<div className="formDetailHeader">
							<CustomReactSelect
								options={props.ItemReceivingTypes}
								name="supervisorComments"
								className="supervisorComments"
								value={props.formFields?.receiviedStatus}
								maxLength="400"
								onChange={(obj) => props.handleStatus(obj)}
							/>
						</div>
					</Col>
				</Row>
			</div>
			<div className="itemReceivingUpdateBtn">
				<Button
					onClick={props.updateItemReceivingSection}
					className="submit-btn"
				>
					Update
				</Button>
			</div>
		</>
	);
};

export default ItemReceivingForm;
